import { useCallback, useState } from 'react';
import fleetApi from '../../services/api.service';

/**
 * Désaffectation groupée : les lignes repassent dans « À placer » en un seul
 * appel, chaque camion touché n'est ré-optimisé qu'une fois
 */
const useUnassignSteps = () => {
  const [isUnassigning, setIsUnassigning] = useState(false);

  const unassignSteps = useCallback(async (tourPlanningIds) => {
    setIsUnassigning(true);
    try {
      const response = await fleetApi.post('/tours-planning/steps/unassign', {
        tour_planning_ids: tourPlanningIds,
      });
      return response.data?.data || { unassignedCount: 0 };
    } catch (err) {
      throw new Error(
        err?.response?.data?.message ||
          err.message ||
          'Impossible de désaffecter les commandes'
      );
    } finally {
      setIsUnassigning(false);
    }
  }, []);

  return { unassignSteps, isUnassigning };
};

export default useUnassignSteps;
